export default {
    TITLE: "Ваш баланс",
    CURRENCY: "₽"
};
